export type SupportedRecipeLocale = 'fr-FR' | 'en';

export const supportedRecipeLocale = (locale: string): SupportedRecipeLocale =>
  locale.toLocaleLowerCase().startsWith('fr') ? 'fr-FR' : 'en';
